import { getCompanyLogo } from 'lib/api/company';
import { expressGetCompanyLogo } from 'lib/api/express';
import { getCompanyPayoutGroup } from 'lib/api/payments';
import { showAlert } from 'lib/functions/utils';
import { Dispatch } from 'redux';

import { PaymentRequestPassiveCheckboxesState } from '../hooks/usePaymentRequestPassiveCheckboxes';
import { generatePaymentRequestPassivePDF } from '../index';
import { PaymentRequestPassiveExportRequest } from '../PaymentRequestPassiveReportGenerator';

export interface ExportPaymentRequestPassiveOptions {
  dispatch: Dispatch;
  user: any;
  request: PaymentRequestPassiveExportRequest;
  checkboxes: PaymentRequestPassiveCheckboxesState;
  canShowPayouts?: boolean;
}

export const handleExportPaymentRequestPassive = async (
  options: ExportPaymentRequestPassiveOptions,
): Promise<void> => {
  const {
    dispatch,
    user,
    request,
    checkboxes,
    canShowPayouts = false,
  } = options;

  try {
    // Obtener payouts si es necesario
    let payouts = null;
    if (canShowPayouts && checkboxes.showPayouts) {
      const requestId = request.id || request.sourceId;
      if (requestId) {
        try {
          payouts = await getCompanyPayoutGroup(
            dispatch,
            'payment-request-passive',
            requestId,
          );
        } catch (error) {
          console.error('Error obteniendo payouts:', error);
        }
      }
    }

    // Obtener logo
    const imageBase64 = user?.express
      ? await expressGetCompanyLogo(dispatch, user.clientId as string)
      : await getCompanyLogo(dispatch);

    // Construir request con las opciones de checkboxes
    const exportRequest: PaymentRequestPassiveExportRequest = {
      ...request,
      // Filtrar datos según checkboxes
      pendingAccounts: checkboxes.showPendingAccounts
        ? request.pendingAccounts
        : [],
      documentsApplied: checkboxes.showAppliedDocuments
        ? request.documentsApplied
        : [],
      // Incluir opciones de checkboxes
      showPendingAccounts: checkboxes.showPendingAccounts,
      showAppliedDocuments: checkboxes.showAppliedDocuments,
      showPayouts: checkboxes.showPayouts,
      showClientInfo: checkboxes.showClientInfo,
      showDates: checkboxes.showDates,
      showAmounts: checkboxes.showAmounts,
      showObservation: checkboxes.showObservation,
      observation: request.observation || null,
    };

    // Generar PDF
    await generatePaymentRequestPassivePDF(
      exportRequest,
      user?.name || '',
      imageBase64,
      payouts,
    );

    showAlert(dispatch, 'success', 'Liquidación exportada correctamente');
  } catch (error) {
    console.error(error);
    showAlert(dispatch, 'error', 'Error al exportar liquidación');
    throw error;
  }
};
